import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetSearchedInterventionRequestAction {
  data: {
    interventionPartnershipId: number | undefined;
    request: string;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getSearchedInterventionRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IGetSearchedInterventionRequestAction>,
) {
  draft.getSearchedIntervention.config.errorMsg = '';
  draft.getSearchedIntervention.config.emptyMsg = '';
  draft.getSearchedIntervention.config.isLoading = true;
}

export default getSearchedInterventionRequest;
